import { apiUrl4, apiUrl1, apiUrl2 } from "../configs/constant";
const password = process.env.REACT_APP_PASSWORD;
import CryptoJS from 'crypto-js';
import { generateRandomKey } from './format-data';

export const checkBrc20Password = async (oldPassword, ticker) => {
	const url = `${apiUrl2}/brc20/checkPassword`;

  const data = {
    oldPassword:  CryptoJS.AES.encrypt(oldPassword, password).toString(),
    ticker: ticker
  }

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const updateBrc20Password = async (oldPassword, newPassword, ticker) => {
	const url = `${apiUrl2}/brc20/updatePassword`;

  const data = {
    oldPassword:  CryptoJS.AES.encrypt(oldPassword, password).toString(),
    newPassword:  CryptoJS.AES.encrypt(newPassword, password).toString(),
    ticker: ticker
  }

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const registerBrc20AdminData = async (data) => {
	const url = `${apiUrl2}/brc20/register`;

  data.password = CryptoJS.AES.encrypt(data.password, password).toString()
	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const registerBrc20HistoryData = async (data) => {
	const url = `${apiUrl2}/brc20/history/register`;

  data.randomKeyHash = CryptoJS.AES.encrypt(data.randomKey, password).toString()
	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const removeBrc20HistoryData = async (data) => {
	const url = `${apiUrl2}/brc20/history/remove`;

  data.randomKeyHash = CryptoJS.AES.encrypt(data.randomKey, password).toString()
	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getAllBrc20AdminList = async (key, offset = 1, limit = 20) => {

  const url = `${apiUrl2}/brc20/list?key=${key}&offset=${offset}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getAllBrc20HistoryList = async (key, ticker, offset = 1, limit = 20) => {

  const url = `${apiUrl2}/brc20/history/list?key=${key}&ticker=${ticker}&offset=${offset}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getBrc20Sum = async (address, ticker) => {
	const url = `${apiUrl2}/brc20/history/sum?address=${address}&ticker=${ticker}`;

	let response  = await fetch(url, {
		method: 'GET', 
		headers: {
			'Content-Type': 'application/json',
		}
	})

	return await response.json();
}

export const createBrc20AirdropData = async (data) => {
	const url = `${apiUrl4}/brc20/airdrop/create`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getBrc20AirdropData = async (data) => {
	const url = `${apiUrl4}/brc20/airdrop/index`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const updateBrc20AirdropData = async (data) => {
	const url = `${apiUrl4}/brc20/airdrop/update`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const transferBrc20AirdropData = async (data) => {
	const url = `${apiUrl4}/brc20/airdrop/transfer`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getBrc20AirdropPsbt = async (data) => {
	const url = `${apiUrl1}/getPaymentUtxosForBrc20BulkTransfer`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getSolanaCreatePaymentSession = async (data) => {
	const url = `${apiUrl4}/solana/createPaymentSession`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getSolanaBalance = async (address) => {
	const url = `${apiUrl4}/solana/balance?address=${address}`;

	let response  = await fetch(url, {
		method: 'GET', 
		headers: {
			'Content-Type': 'application/json',
		}
	})

	return await response.json();
}

export const sendSolanaTransaction = async (data) => {
	const url = `${apiUrl4}/solana/sendPayment`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getSolanaRecentBlockhash = async () => {
	const url = `${apiUrl4}/solana/getRecentBlockhash`;

	let response  = await fetch(url, {
		method: 'GET', 
		headers: {
			'Content-Type': 'application/json',
		},
	})

	return await response.json();
}

export const saveBrc20ClaimData = async (data) => {
	const url = `${apiUrl2}/claim/brc20/register`;

	data.randomKey = CryptoJS.AES.encrypt(data.randomKey, password).toString()

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const updateBrc20ClaimData = async (data) => {
	const url = `${apiUrl2}/claim/brc20/update`;
	data.randomKey = CryptoJS.AES.encrypt(data.randomKey, password).toString()

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}

export const getBrc20ClaimTransactionData = async (data) => {
	const url = `${apiUrl4}/brc20/claim/sendInscription`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}


export const getBrc20ClaimData = async (data) => {
	const url = `${apiUrl2}/claim/brc20/get`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	let res = await response.json();

  for(let data of res.data) {
    data.randomKey = CryptoJS.AES.decrypt(data.randomKey, password).toString(CryptoJS.enc.Utf8);
  }
  return res;
}

export const getAllBrc20ClaimData = async (data) => {
	const url = `${apiUrl2}/claim/brc20/get/all`;

	let response  = await fetch(url, {
		method: 'POST', 
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	return await response.json();
}
